<script lang="ts">
  import { scale } from "svelte/transition";
  import { cubicOut } from "svelte/easing";

  interface Props {
    checked?: boolean;
    name?: string;
    id?: string;
    class?: string;
    onCheckedChange?: (checked: boolean) => void;
  }

  let { checked = false, name, id, class: className, onCheckedChange }: Props = $props();

  function toggle(e: Event) {
    e.preventDefault();
    if (onCheckedChange) onCheckedChange(!checked);
  }
</script>

<div
  class="relative flex cursor-pointer items-center gap-1.5 text-sm transition-colors {className}"
  class:text-primary-600={checked}
  class:text-foreground-primary={!checked}
  role="checkbox"
  aria-checked={checked}
  onclick={toggle}
  onkeydown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggle(e);
    }
  }}
  tabindex="0"
>
  <button
    class="relative flex h-3.5 w-3.5 items-center justify-center overflow-hidden rounded-[5px] border border-mono-400 transition-all duration-200 ease-out"
    aria-checked={checked}
    onclick={(e) => {
      e.stopPropagation();
      toggle(e);
    }}
    role="checkbox"
    type="button"
    {name}
    {id}
  >
    {#if checked}
      <div
        transition:scale={{ start: 0.1, duration: 200, easing: cubicOut, opacity: 1 }}
        class="flex h-full w-full items-center justify-center rounded-[3px] bg-pri-800"
      >
        <svg width="8" height="8" viewBox="0 0 10 10" fill="none">
          <path
            d="M2 5.5L4 7.5L8 2.5"
            stroke="var(--color-mono-000)"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    {/if}
  </button>

  <input class="sr-only" {checked} type="checkbox" tabindex="-1" readonly />
</div>
